import React from 'react';
import Script from 'next/script';
import { isPhone } from 'base/utils/client';

export const RemInstaller: React.FC = () => {
    // <script src="/js/rem.js"/>
    return isPhone ? (
        <Script
            id={'rem'}
            strategy="beforeInteractive"
            dangerouslySetInnerHTML={{
                __html: `!function(){function e(){var e=window.innerWidth?window.innerWidth:document.documentElement.offsetWidth;let t=Math.round(24*(e=Math.min(Math.max(e,320),750))/750*1e4)/1e4,$=document.getElementsByTagName("html")[0];$.style.cssText="font-size: "+t+"px";let n=1e4*+window.getComputedStyle($).fontSize.replace("px","")/1e4;t!==n&&($.style.cssText="font-size: "+t*(t/n)+"px")}if("undefined"!=typeof window){var t,$,n;e(),t=window,$=e,n=void 0!==n&&n,t.addEventListener("resize",$,n)}}();`
            }}/>
    ) : (
        <Script
            id={'rem'}
            strategy="beforeInteractive"
            dangerouslySetInnerHTML={{
                __html: `(function(){function c(){if(!document.body)return/(iPad|iPhone|iPod|Android|ios|Windows Phone)/i.test(window.navigator.userAgent)?0:15;if(document.body.scrollHeight>(window.innerHeight||document.documentElement.clientHeight)){var a=document.createElement("div");a.style.cssText="position:absolute; top:-1000px; width:100px; height:100px; overflow:hidden;";var d=document.body.appendChild(a).clientWidth;a.style.overflowY="scroll";var e=a.clientWidth;document.body.removeChild(a);return d-e}return 0}function b(){var a=
(window.innerWidth?window.innerWidth:document.documentElement.offsetWidth)-c();a=Math.max(a,768);a=Math.round(a/1920*1E4)/1E4;document.getElementsByTagName("html")[0].style.cssText="font-size: "+a+"px"}"undefined"!==typeof window&&(b(),window.addEventListener("resize",b,!1))})();`
            }}/>
    )
};